import { isSafeReviewText } from "../lib/review-text";
import { CyraError } from "./errors";
import type { ImportInvestigation } from "./partner-import-models";

export function assertImportInvestigation(value: unknown): asserts value is ImportInvestigation {
  if (
    !value ||
    typeof value !== "object" ||
    Array.isArray(value) ||
    Object.keys(value).some((key) => key !== "reason") ||
    !("reason" in value) ||
    typeof value.reason !== "string" ||
    value.reason.trim().length < 3 ||
    value.reason.length > 500 ||
    !isSafeReviewText(value.reason)
  )
    throw invalidInvestigation();
  // URI encoding must be lossless, including rejection of unpaired UTF-16 surrogates.
  try {
    encodeURIComponent(value.reason);
  } catch {
    throw invalidInvestigation();
  }
}

export function importInvestigationHeader(investigation?: ImportInvestigation) {
  if (investigation === undefined) return {};
  assertImportInvestigation(investigation);
  return { "x-cyra-investigation-reason": encodeURIComponent(investigation.reason) };
}

function invalidInvestigation() {
  return new CyraError({
    code: "VALIDATION_FAILED",
    status: 422,
    requestId: "import-investigation",
    message: "An explicit safe investigation reason of 3–500 characters is required.",
  });
}
